import { FileUp } from "lucide-react";
import DatePicker from "../DatePicker";
import FileUpload from "../FormComponents/FileUpload";
const CustomerAdminForm = ({ newUser, setNewUser, errors, setErrors, employeeConfig, isViewMode, isEdit }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {/* Row 1: Company and Employee Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Company <span className="text-red-500">*</span></label>
        <input
          type="text"
          maxLength={250}
          value={newUser.company}
          onChange={(e) => {
            setNewUser({ ...newUser, company: e.target.value });
            setErrors(prev => ({ ...prev, company: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.company ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter company name"
        />
        {errors.company && <p className="text-red-500 text-xs mt-1">{errors.company}</p>}
      </div>   


      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">First Name <span className="text-red-500">*</span></label>
        <input
          type="text"
          maxLength={250}
          value={newUser.firstname}
          onChange={(e) => {
            setNewUser({ ...newUser, firstname: e.target.value });
            setErrors(prev => ({ ...prev, firstname: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.firstname ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter first name"
        />
        {errors.firstname && <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>}
      </div>   


      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
        <input
          type="text"
          maxLength={250}
          value={newUser.lastname}
          onChange={(e) => setNewUser({ ...newUser, lastname: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
          placeholder="Enter last name"

        />
      </div>

      {/* Row 2: Employee Count and Price */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Employee Count <span className="text-red-500">*</span>
        </label>
        <select
          value={newUser.employeecount || ""}
          onChange={(e) => {
            const selectedRange = e.target.value;
            const selectedConfig = employeeConfig.find(c => c.name === selectedRange);
            setNewUser({
              ...newUser,
              employeecount: selectedRange,
              price: selectedConfig ? selectedConfig.value : ""
            });
            setErrors(prev => ({ ...prev, employeecount: undefined, price: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.employeecount ? "border-red-500" : "border-gray-300"
            }`}
        >
          <option value="">-- Select Employee Range --</option>
          {employeeConfig.map((config) => (
            <option key={config._id} value={config.name}>
              {config.name}
            </option>
          ))}
        </select>
        {errors.employeecount && <p className="text-red-500 text-xs mt-1">{errors.employeecount}</p>}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Price <span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">$</span>
          <input
            type="number"
            value={newUser.price || ""}
            onChange={(e) => {
              setNewUser({ ...newUser, price: e.target.value });
              setErrors(prev => ({ ...prev, price: undefined }));
            }}
            className={`w-full border rounded-lg pl-8 pr-3 py-2 ${errors.price ? "border-red-500" : "border-gray-300"
              }`}
            placeholder="0.00"
            min="0"
          />
        </div>
        {errors.price && <p className="text-red-500 text-xs mt-1">{errors.price}</p>}
      </div>

      {/* Row 3: Email and Phone */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email <span className="text-red-500">*</span></label>
        <input
          type="email"
          value={newUser.email}
          readOnly={isEdit}
          onChange={isEdit ? undefined : (e) => {
            setNewUser({ ...newUser, email: e.target.value });
            setErrors((prev) => ({ ...prev, email: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.email ? "border-red-500" : "border-gray-300"} ${isEdit ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""}`}
          placeholder="Enter email address"
        />
        {errors.email && (
          <p className="text-red-500 text-xs mt-1">{errors.email}</p>
        )}
      </div>


      {/* Phone */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
        <input
          type="tel"
          maxLength={10}
          value={newUser.phone}
          onChange={(e) => {
            setNewUser({ ...newUser, phone: e.target.value });
            setErrors(prev => ({ ...prev, phone: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.phone ? "border-red-500" : "border-gray-300"
            }`}
          placeholder="Enter phone number"
        />
        {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
      </div>

      {/* Row 4: Location and Status */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Location</label>
        <input
          type="text"
          maxLength={250}
          value={newUser.location}
          onChange={(e) => setNewUser({ ...newUser, location: e.target.value })}
          className="w-full border border-gray-300 rounded-lg px-3 py-2"
          placeholder="Enter location"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Status <span className="text-red-500">*</span></label>
        <select
          value={newUser.status}
          onChange={(e) => {
            setNewUser({ ...newUser, status: e.target.value });
            setErrors(prev => ({ ...prev, status: undefined }));
          }}
          className={`w-full border rounded-lg px-3 py-2 ${errors.status ? "border-red-500" : "border-gray-300"
            }`}
        >
          <option value="">Select status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
          <option value="suspended">Suspended</option>
        </select>
        {errors.status && <p className="text-red-500 text-xs mt-1">{errors.status}</p>}
      </div>

      {/* Row 5: Renewal Date */}
      <div>
        <DatePicker
          value={newUser.renewal_date || ""}
          onChange={(date) => setNewUser({ ...newUser, renewal_date: date })}
          disabled={isViewMode}
          label="Renewal Date"
        />
        {!newUser.renewal_date && <p className="text-sm text-gray-500 mt-1">If no date is selected, 1 year will be set automatically.</p>}
      </div>
      <div>
        <FileUpload
          value={newUser.logoImg || ""}
          onChange={(logoImg) => setNewUser({ ...newUser, logoImg: logoImg })}
          disabled={isViewMode}
          label="Company Logo"
          required={true}
          helperText="Upload a logo image (JPG, PNG, SVG)"
          allowedTypes={["image/jpeg", "image/png", "image/svg+xml"]}
          error={errors.logoImg}
          
        />

        {errors.logoImg && (
          <p className="text-red-500 text-xs mt-1">
            {errors.logoImg}
          </p>
        )}
        
        {newUser.logoImg &&
          typeof newUser.logoImg === "string" && (
            <div className="mt-3">
              <img
                src={newUser.logoImg}
                alt="Company Logo"
                className="h-20 w-auto border rounded-lg p-1 bg-white"
              />
            </div>
          )}
      </div>
      
    </div>
  );
};

export default CustomerAdminForm;